import type { ComponentProps } from 'react'
import type { VariantProps } from '@joyful/utils'
import { tv } from '@joyful/utils'

export const separatorVariants = tv({
  base: 'block bg-tremor-border shrink-0',

  compoundVariants: [
    {
      className: 'h-px',
      pattern: 'solid',
      thickness: 'thin',
      variant: 'horizontal',
    },
    {
      className: 'h-0.5',
      pattern: 'solid',
      thickness: 'thick',
      variant: 'horizontal',
    },
    {
      className: 'w-px',
      pattern: 'solid',
      thickness: 'thin',
      variant: 'vertical',
    },
    {
      className: 'w-0.5',
      pattern: 'solid',
      thickness: 'thick',
      variant: 'vertical',
    },
    {
      className: 'h-0 border-t border-dashed border-tremor-border',
      pattern: 'dashed',
      thickness: 'thin',
      variant: 'horizontal',
    },
    {
      className: 'h-0 border-t-2 border-dashed border-tremor-border',
      pattern: 'dashed',
      thickness: 'thick',
      variant: 'horizontal',
    },
    {
      className: 'w-0 border-l border-dashed border-tremor-border',
      pattern: 'dashed',
      thickness: 'thin',
      variant: 'vertical',
    },
    {
      className: 'w-0 border-l-2 border-dashed border-tremor-border',
      pattern: 'dashed',
      thickness: 'thick',
      variant: 'vertical',
    },
  ],

  defaultVariants: {
    pattern: 'solid',
    thickness: 'thin',
    variant: 'horizontal',
  },

  variants: {
    pattern: {
      dashed: 'bg-transparent',
      solid: null,
    },
    thickness: {
      thick: null,
      thin: null,
    },
    variant: {
      horizontal: 'w-full',
      vertical: 'self-stretch',
    },
  },
})

export type SeparatorProps = VariantProps<typeof separatorVariants> &
  Omit<ComponentProps<'div'>, 'className'>

export function Separator({
  pattern,
  thickness,
  variant,
  ...props
}: SeparatorProps) {
  return (
    <div
      {...props}
      className={separatorVariants({
        pattern,
        thickness,
        variant,
      })}
    />
  )
}
